// extracted by mini-css-extract-plugin
module.exports = {"fromItem":"fromItem--YM_wk","formItemContent":"formItemContent--2_E7m","formItemLabel":"formItemLabel--EmcJt","formItemError":"formItemError--2JhE1"};